import classNames from 'classnames';
import { ReactNode } from 'react';
import './HeaderText.scss';

export interface IHeaderTextProps {
  title: string;
  children?: ReactNode;
  className?: string | object;
}

const HeaderText = ({ title, children, className }: IHeaderTextProps) => {
  const classes = classNames('header-text', className);

  return (
    <div className={classes}>
      <div className="header-title">{title}</div>
      {children}
    </div>
  );
};

export default HeaderText;
